import React from "react";
import "../styles/PolicyPages.css";

const CerezPolitikasi = () => {
  return (
    <div className="policy-page">
      <h1>Çerez Politikası</h1>
      <p>
        <strong>Son Güncelleme:</strong> 09.04.2026
      </p>
      <p>
        Patili Dostlar olarak, web sitemizde çerezler ve benzeri teknolojiler
        kullanabiliriz. Bu politika, çerezlerin hangi amaçlarla kullanıldığını,
        hangi tür çerezlerin işlendiğini ve tercihlerinizi nasıl
        yönetebileceğinizi açıklamaktadır.
      </p>

      <h3>1. Çerez Nedir?</h3>
      <p>
        Çerezler, ziyaret ettiğiniz internet siteleri tarafından tarayıcınız
        aracılığıyla cihazınıza kaydedilen küçük metin dosyalarıdır. Çerezler,
        site deneyiminizi geliştirmek ve belirli işlevleri yerine getirmek için
        kullanılabilir.
      </p>

      <h3>2. Kullanılan Çerez Türleri</h3>
      <ul>
        <li>
          <strong>Zorunlu çerezler:</strong> Sitenin temel işlevlerinin doğru
          şekilde çalışması için gereklidir.
        </li>
        <li>
          <strong>İşlevsel çerezler:</strong> Tercihlerinizin hatırlanmasına ve
          kullanıcı deneyiminin iyileştirilmesine yardımcı olur.
        </li>
        <li>
          <strong>Analitik çerezler:</strong> Site kullanımını anlamamıza ve
          hizmet kalitemizi geliştirmemize yardımcı olur.
        </li>
      </ul>

      <h3>3. Çerezlerin Kullanım Amaçları</h3>
      <ul>
        <li>Oturum yönetimi ve güvenlik sağlamak.</li>
        <li>Kullanıcı tercihlerini hatırlamak.</li>
        <li>Site performansını ölçmek ve iyileştirmek.</li>
        <li>Kullanıcı deneyimini daha işlevsel hale getirmek.</li>
      </ul>

      <h3>4. Çerezlerin Yönetimi</h3>
      <p>
        Tarayıcı ayarlarınızı kullanarak çerezleri kabul edebilir, reddedebilir
        veya mevcut çerezleri silebilirsiniz. Ancak zorunlu çerezlerin
        engellenmesi halinde sitenin bazı bölümleri veya işlevleri düzgün
        çalışmayabilir.
      </p>

      <h3>5. Üçüncü Taraf Çerezleri</h3>
      <p>
        Gerekli görülmesi halinde, hizmet sağlayıcılar tarafından sağlanan
        üçüncü taraf araçlar üzerinden çerezler kullanılabilir. Bu tür çerezler,
        yalnızca ilgili hizmetin sunulması ve performansın ölçülmesi amacıyla
        sınırlı şekilde kullanılabilir.
      </p>

      <h3>6. Politika Değişiklikleri</h3>
      <p>
        Bu Çerez Politikası, yasal düzenlemeler ve teknik ihtiyaçlar
        doğrultusunda güncellenebilir. Güncel metin sitede yayımlandığı anda
        yürürlüğe girer.
      </p>

      <h3>7. İletişim</h3>
      <p>
        Çerez kullanımıyla ilgili sorularınız için bizimle site üzerindeki
        iletişim kanalları veya e-posta adresi üzerinden iletişime
        geçebilirsiniz.
      </p>
    </div>
  );
};

export default CerezPolitikasi;
